const useAllPosts = async(): Promise<object> => {
  const { data } = await useAsyncData('', async () => {
      const posts = await queryCollection("posts").all();

      //sort by date desc
      return posts?.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime()
      });
    });
  return data;
}

const usePostUri = async(slug: string): Promise<object> => {
    const {data: page} = await useAsyncData(slug, async () => {
      
      let page = await queryCollection("posts").where("slug", "=", slug).first();
      
      if (!page) {
        const alternatePath = slug.endsWith('/') 
          ? slug.slice(0, -1) 
          : slug + '/';
  
        page = await queryCollection("posts").where("slug", "=", alternatePath).first();
      }
  
      return page;
    });
  
    return page?.value?.body || {};
}

export {
    useAllPosts,
    usePostUri
};